export const apiUrl = {
  get_blog: "blog/get-list?",
  get_blog_details: "blog/get/",
  add_mail: "mail/create",
  add_message: "message/add",
  get_faq: "faq/getAll",
  get_meta: "superAdmin/get-Meta?",
  refund_request: "superAdmin/refund-request",
  request_deactivate: "superAdmin/account-request"
};
